// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_Rmk","cls2":"SimplePaperPodcast-cls2_zRd SimplePaperPodcast-cls1_Rmk"};